(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"));
	else if(typeof define === 'function' && define.amd)
		define(["d3"], factory);
	else if(typeof exports === 'object')
		exports["EhsReact"] = factory(require("d3"));
	else
		root["EhsReact"] = factory(root["d3"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__373__) {
return 